import { render } from "./create.vue?vue&type=template&id=36d7868e"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/maintenance_histories/create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36d7868e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36d7868e', __exports__)) {
    console.log('reload')
    api.reload('36d7868e', __exports__)
  }
  
  module.hot.accept("./create.vue?vue&type=template&id=36d7868e", () => {
    console.log('re-render')
    api.rerender('36d7868e', render)
  })

}


export default __exports__